import angular from 'angular';
import './supergroups';
import './domains';
import './subgroups';

export default angular.module('adminPanel.adminEntities', [
  'adminPanel.adminEntities.supergroups',
  'adminPanel.adminEntities.domains',
  'adminPanel.adminEntities.subgroups'
]);